<template>
  <div class="channel-rules">
    <div class="channel-rules__toolbar">
      <el-button type="primary" size="mini" @click="toAddRule">新增规则</el-button>
    </div>

    <el-table v-if="!isMobileViewport" :data="list" border stripe v-loading="loading">
      <el-table-column label="规则名称" min-width="180" align="center">
        <template slot-scope="{ row }">
          {{ row.appRules && row.appRules.name ? row.appRules.name : "--" }}
        </template>
      </el-table-column>
      <el-table-column label="规则说明" min-width="220" align="center">
        <template slot-scope="{ row }">
          {{ row.appRules && row.appRules.remark ? row.appRules.remark : "--" }}
        </template>
      </el-table-column>
      <el-table-column label="检测值" min-width="160" align="center">
        <template slot-scope="{ row }">
          {{ row.value || (row.appRules && row.appRules.value) || "--" }}
        </template>
      </el-table-column>
      <el-table-column label="提示信息" min-width="180" align="center">
        <template slot-scope="{ row }">
          {{ row.msg || (row.appRules && row.appRules.remark) || "--" }}
        </template>
      </el-table-column>
      <el-table-column prop="time" label="时间(秒)" width="100" align="center" />
      <el-table-column label="处罚类型" width="100" align="center">
        <template slot-scope="{ row }">
          {{ Number(row.type) === 1 ? "警告" : "封禁" }}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        :width="isMobileViewport ? 76 : 150"
        align="center"
        fixed="right"
      >
        <template slot-scope="{ row }">
          <responsive-actions
            :items="channelRuleRowActions"
            @select="handleChannelRuleRowAction($event, row)"
          />
        </template>
      </el-table-column>
    </el-table>
    <mobile-record-list
      v-else
      :rows="list"
      :loading="loading"
      :title="getMobileChannelRuleTitle"
      :subtitle="getMobileChannelRuleSubtitle"
      :fields="mobileChannelRuleFields"
      :actions="channelRuleRowActions"
      @action="handleChannelRuleRowAction"
    />

    <el-dialog title="新增规则" :visible.sync="addDialogVisible" width="720px">
      <el-table v-if="!isMobileViewport" :data="ruleList" border stripe>
        <el-table-column prop="name" label="规则名称" min-width="180" align="center" />
        <el-table-column prop="remark" label="说明" min-width="240" align="center" />
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="{ row }">
            <el-button
              type="primary"
              size="mini"
              :disabled="row.disabled"
              @click="addRule(row)"
            >
              添加
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <mobile-record-list
        v-else
        :rows="ruleList"
        :title="getMobileAvailableRuleTitle"
        :subtitle="getMobileAvailableRuleSubtitle"
        :fields="mobileAvailableRuleFields"
        :actions="getAvailableRuleActions"
        @action="handleAvailableRuleAction"
      />
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="addDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog title="修改规则" :visible.sync="editRuleDialogVisible" width="420px">
      <el-form ref="editFormRef" :model="editForm" label-width="90px" size="mini">
        <el-form-item label="检测值">
          <el-input v-model.trim="editForm.value" :disabled="disabled" />
        </el-form-item>
        <el-form-item
          v-if="Number(editForm.rule_id) === 21 || Number(editForm.rule_id) === 23"
          label="次数"
        >
          <el-input
            v-model.trim="editForm.num"
            type="number"
            min="1"
            step="1"
            placeholder="大于 0 才启用规则"
          />
        </el-form-item>
        <el-form-item label="提示信息">
          <el-input v-model.trim="editForm.msg" />
        </el-form-item>
        <el-form-item label="时间(秒)">
          <el-input v-model.trim="editForm.time" type="number" />
        </el-form-item>
        <el-form-item label="处罚类型">
          <el-select v-model="editForm.type" style="width: 100%" clearable placeholder="请选择">
            <el-option v-for="item in punishList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="editRuleDialogVisible = false">取消</el-button>
        <el-button type="primary" size="mini" @click="saveRules">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import responsiveMixin from "@/mixins/responsive";

export default {
  mixins: [responsiveMixin],
  props: {
    type: {
      type: [String, Number],
      default: "",
    },
    channelId: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      list: [],
      ruleList: [],
      addDialogVisible: false,
      editRuleDialogVisible: false,
      ruleForm: {
        time: 60,
        msg: "",
        type: "2",
      },
      editForm: {},
      disabled: false,
      punishList: [
        { id: "1", name: "警告" },
        { id: "2", name: "封禁" },
      ],
    };
  },
  computed: {
    mobileChannelRuleFields() {
      return [
        { label: "检测值", value: (row) => row.value || (row.appRules && row.appRules.value) },
        { label: "处罚类型", value: (row) => (Number(row.type) === 1 ? "警告" : "封禁") },
        { label: "时间", value: (row) => `${row.time || 0} 秒` },
        { label: "提示信息", value: (row) => row.msg || (row.appRules && row.appRules.remark) },
        { label: "规则ID", key: "id", summary: false },
        { label: "规则说明", value: (row) => row.appRules && row.appRules.remark, summary: false },
      ];
    },
    mobileAvailableRuleFields() {
      return [
        { label: "说明", key: "remark" },
        { label: "默认检测值", key: "value" },
        { label: "规则KEY", key: "key" },
        { label: "规则ID", key: "id" },
      ];
    },
    channelRuleRowActions() {
      return [
        { key: "edit", label: "修改", type: "primary" },
        { key: "delete", label: "删除", type: "danger" },
      ];
    },
  },
  methods: {
    getMobileChannelRuleTitle(row) {
      return (row.appRules && row.appRules.name) || `规则 #${row.id}`;
    },
    getMobileChannelRuleSubtitle(row) {
      return `渠道规则ID ${row.id}`;
    },
    getMobileAvailableRuleTitle(row) {
      return row.name || `规则 #${row.id}`;
    },
    getMobileAvailableRuleSubtitle(row) {
      return row.disabled ? "已添加" : "可添加";
    },
    getAvailableRuleActions(row) {
      return [{ key: "add", label: "添加", type: "primary", disabled: row.disabled }];
    },
    handleAvailableRuleAction(key, row) {
      if (key === "add") this.addRule(row);
    },
    handleChannelRuleRowAction(key, row) {
      if (key === "edit") this.editRules(row);
      if (key === "delete") this.delChannelRule(row);
    },
    async delChannelRule(row) {
      this.$confirm("删除后不可恢复，确认删除该规则吗？", "删除规则", {
        type: "warning",
      }).then(async () => {
        const data = await this.$api.getChannel.deleteChannelRule({ id: row.id });
        if (data.code === 200) {
          this.$message.success("删除成功");
          this.getChannelRuleList();
        }
      });
    },
    async editRules(row) {
      this.disabled = row.appRules && Number(row.appRules.is_show) === 1;
      const data = await this.$api.getChannel.getChannelRuleInfo({ id: row.id });
      if (data.code === 200) {
        this.editForm = { ...data.data };
        this.editRuleDialogVisible = true;
      }
    },
    async saveRules() {
      const data = await this.$api.getChannel.saveChannelRule({
        ...this.editForm,
      });
      if (data.code === 200) {
        this.$message.success("保存成功");
        this.editRuleDialogVisible = false;
        this.getChannelRuleList();
      }
    },
    addRule(row) {
      const params = {
        ...this.ruleForm,
        rule_type: String(this.type),
        rule_id: row.id,
        channel_id: this.channelId,
      };

      this.$confirm("确认新增该规则吗？", "新增规则", {
        type: "warning",
      }).then(async () => {
        const data = await this.$api.getChannel.addChannelRule(params);
        if (data.code === 200) {
          row.disabled = true;
          this.$message.success("新增成功");
          this.getChannelRuleList();
        }
      });
    },
    async getRules() {
      const data = await this.$api.getAppRules.getAppRulesList();
      this.ruleList = (data.data || []).map((item) => ({
        ...item,
        disabled: false,
      }));
      this.refreshRuleDisabled();
    },
    async getChannelRuleList() {
      if (!this.channelId) {
        this.list = [];
        return;
      }

      this.loading = true;
      try {
        const data = await this.$api.getChannel.getChannelRuleList({
          rule_type: this.type,
          channel_id: this.channelId,
        });
        this.list = Array.isArray(data.data) ? data.data : [];
        this.refreshRuleDisabled();
      } finally {
        this.loading = false;
      }
    },
    refreshRuleDisabled() {
      const listIds = this.list.map((item) => String(item.rule_id));
      this.ruleList = this.ruleList.map((item) => ({
        ...item,
        disabled: listIds.includes(String(item.id)),
      }));
    },
    toAddRule() {
      this.refreshRuleDisabled();
      this.addDialogVisible = true;
    },
  },
  watch: {
    channelId: {
      immediate: true,
      handler() {
        this.getChannelRuleList();
      },
    },
    type() {
      this.getChannelRuleList();
    },
  },
  created() {
    this.getRules();
  },
};
</script>

<style lang="less" scoped>
.channel-rules__toolbar {
  margin-bottom: 12px;
}

/deep/ .el-table .el-table__cell {
  padding: 7px 0;
}
</style>
